import ConstructionIcon from '@mui/icons-material/Construction'
import { Box, Container, Paper, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import LogoMain from 'components/logo/LogoMain'
import React from 'react'

const MaintenanceContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
}))

const MaintenancePaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  textAlign: 'center',
  maxWidth: 500,
  width: '100%',
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[10],
}))

const IconWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '& svg': {
    fontSize: '4rem',
    color: theme.palette.warning.main,
  },
}))

const MaintenancePage: React.FC = () => {
  return (
    <MaintenanceContainer maxWidth={false}>
      <MaintenancePaper elevation={3}>
        <Box sx={{ mb: 3 }}>
          <LogoMain />
        </Box>

        <IconWrapper>
          <ConstructionIcon />
        </IconWrapper>

        <Typography variant="h3" component="h1" gutterBottom color="primary">
          Down for Maintenance
        </Typography>

        <Typography variant="h6" color="text.secondary" paragraph>
          We're currently performing scheduled maintenance to improve your experience.
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          Our team is working hard to get everything back up and running as quickly as possible. We apologize for any
          inconvenience this may cause.
        </Typography>

        <Typography variant="caption" display="block" sx={{ mt: 3 }} color="text.disabled">
          Thank you for your patience.
        </Typography>
      </MaintenancePaper>
    </MaintenanceContainer>
  )
}

export default MaintenancePage
